import { Aggregation, NUMBERS_ONLY_SCHEMA, TimeBucket } from '../../services/constants';
import T from '../../localization/LocalizationKeys';
import MultiLineGraphView from './Views/MultiLineGraphView';
import TableView from './Views/TableView';
import { PRIMITIVE_SCHEMAS } from '../../utils/dtdl';
import ModelType from '../Model/ModelType';
import _ from 'lodash';

export const ChartViews = Object.freeze({
  LINE_GRAPH_VIEW: 'lineGraphView',
  TABLE_VIEW: 'tableView'
});

const MAX_LANES = 4;

const ChartViewData = {
  [ChartViews.LINE_GRAPH_VIEW]: {
    text: T.graph.line.chart.view,
    value: ChartViews.LINE_GRAPH_VIEW,
    component: MultiLineGraphView,
    schemas: NUMBERS_ONLY_SCHEMA,
    aggregation: Object.values(Aggregation),
    timeBuckets: Object.values(TimeBucket),
    models: [
      {
        type: ModelType.COLOR_PICKER,
        path: 'color'
      },
      {
        type: ModelType.TOGGLE_GROUP,
        path: 'laneNumber',
        options: _.map(_.range(MAX_LANES), value => ({ value, text: _.toString(value) })),
        properties: {
          isCompact: true
        }
      }
    ]
  },
  [ChartViews.TABLE_VIEW]: {
    text: T.graph.table.view,
    value: ChartViews.TABLE_VIEW,
    component: TableView,
    schemas: Object.values(PRIMITIVE_SCHEMAS),
    aggregation: Object.values(Aggregation),
    timeBuckets: Object.values(TimeBucket),
    models: [
      {
        type: ModelType.NUMBER_INPUT,
        path: 'decimalPoint',
        properties: {
          widthChars: 2,
          onMinus: (newValue, prevValue, setter) => {
            // No negative values
            setter(newValue < 0 ? prevValue : newValue);
          }
        }
      }
    ]
  }
};
export default ChartViewData;
